import React, { useCallback, useEffect, useRef, useState } from 'react';

import styled, { CSSObject } from 'styled-components';

interface MoreMenuProps {
  style?: CSSObject;
  targetButton: any;
  enableInnerClick?: boolean;
  onClick?: (visible: boolean) => void;
  deps?: Array<any>;
  children: React.ReactElement;
  element?: React.ReactElement;
  capturing?: boolean;
  modalPass?: boolean;
  modalTriggerId?: string;
}

function MoreMenuWrapper({
  style,
  targetButton,
  enableInnerClick = false,
  onClick,
  deps = [],
  children,
  element,
  capturing = false,
  modalPass = false,
  modalTriggerId,
}: MoreMenuProps) {
  const targetWrapperRef = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  const handleClick = useCallback(
    (e: any) => {
      // 특정 id의 노드가 있는 경우, 클릭 시 닫히지 않기 위한 코드
      const pass = !!modalTriggerId && Boolean(document.querySelectorAll(`[id*='${modalTriggerId}']`).length > 0);
      // console.log(pass, modalTriggerId && document.querySelectorAll(`[id*='${modalTriggerId}']`));
      if (visible && modalPass && pass) return;

      // wrapper 안쪽 클릭시
      if (!targetButton.current?.contains(e.target) && targetWrapperRef.current?.contains(e.target as Node)) {
        setVisible(enableInnerClick);
        return;
      }

      if (targetButton.current?.contains(e.target)) {
        setVisible((p) => !p);
        onClick?.(visible);
        return;
      }

      // 버튼 바깥, wrapper 바깥 클릭시
      setVisible(false);
      onClick?.(visible);
    },
    [visible]
  );

  useEffect(() => {
    document.addEventListener('click', handleClick, { capture: capturing });
    return () => document.removeEventListener('click', handleClick, { capture: capturing });
  }, [visible, ...deps]);

  return (
    <>
      {visible && (
        <>
          <SWrapper
            ref={targetWrapperRef}
            className="menuWrapper"
            style={style}
            $visible={visible}
            onClick={(e) => {
              setVisible(true);
              if (capturing) {
                e.stopPropagation();
              }
            }}
          >
            {children}
          </SWrapper>
          {element && <div>{element}</div>}
        </>
      )}
      {visible && <SDim />}
    </>
  );
}

export default MoreMenuWrapper;

interface WrapperProps {
  style: any;
  $visible: boolean;
}

const SWrapper = styled.div<WrapperProps>`
  width: max-content;
  display: ${(props) => (props.$visible ? 'flex' : 'none')};
  position: absolute;
  flex-direction: column;
  justify-content: center;
`;

const SDim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  background: transparent;
  cursor: default;
`;
